export default {
  data () {
    return {
      bsBlue: '#006DFF',
      bsRose: '#ED047C'
    }
  }
}